import $ from "jquery";
import Swal from "sweetalert2";

const formHomeSeo = () => {
  const page = $("#mi-Form-Home-Seo").length;
  if (page < 1) return;

  const el = {
    formHome: "#mi-Form-Home-Seo",
    formPopup: "#mi-Form-Popup-Seo",
  };

  const init = () => {
    addValueToPopup();
    handleSubmitPopup();
  };

  const addValueToPopup = () => {
    $(document).on("submit", el.formHome, function (event) {
      event.preventDefault(); // Prevent default form submission behavior if needed

      // console.log($('input[name="form_fields[url_website_field]"]').val());
      const url = $('input[name="form_fields[url_website_field]"]').val();

      // Observer logic to watch for changes after submission
      const observeElementAfterSubmit = () => {
        if ($(".mi-FormWrapperSeo").length) {
          observer.disconnect();

          $("#url_website").val(url);
        }
      };

      const observer = new MutationObserver(() => {
        observeElementAfterSubmit();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      observeElementAfterSubmit();
    });
  };

  const loadingStateElement = $(
    '<div id="loading-state" class="loading-state fade-in" style="display:none"><div class="loading"></div></div>'
  );

  $(function () {
    loadingStateElement.fadeOut();
  });
  $("body").append(loadingStateElement);

  const handleSubmitPopup = () => {
    $(document).on("submit", el.formPopup, function (event) {
      event.preventDefault();
      event.stopPropagation();

      const formData = new FormData(this);

      const validate = () => {
        let isValidate = true;
        if ($(".error-message").length > 0) {
          $(".error-message").remove();
        }
        $(el.formPopup + " input:visible").each(function () {
          $(this).closest(".mi-Form__Top__Input").removeClass("error");
          const inputValue = $(this).val();

          const validateEmail = (email) => {
            const emailRegex =
              /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

            return emailRegex.test(email); // Returns true if valid, false otherwise
          };

          if (inputValue === "") {
            const labelText = $(this).siblings("label").text();
            const errorMessage = `<span class="error-message">${labelText} mag niet leeg zijn</span>`;

            $(this).closest(".mi-Form__Top__Input").addClass("error");
            $(this).after(errorMessage);
            isValidate = false;
          } else if (
            $(this).attr("id") === "email" &&
            !validateEmail(inputValue)
          ) {
            const errorMessage = `<span class="error-message">E-mail is niet in het juiste formaat</span>`;

            $(this).closest(".mi-Form__Top__Input").addClass("error");
            $(this).after(errorMessage);
            isValidate = false;
          }
        });

        return isValidate;
      };

      // if (validate()) {
      //   console.log(formData);
      //   window.location.href = "/thank-you-seo";
      // }

      if (validate()) {
        // eslint-disable-next-line no-undef
        formData.append("action", themeObj.ajax.scan_ecommerce_seo.action);
        // eslint-disable-next-line no-undef
        formData.append("nonce", themeObj.ajax.scan_ecommerce_seo.nonce);

        $(document)
          .ajaxStart(function () {
            loadingStateElement.fadeIn();
          })
          .ajaxStop(function () {
            loadingStateElement.fadeOut();
          });

        $.ajax({
          // eslint-disable-next-line no-undef
          url: themeObj.ajaxUrl,
          method: "POST",
          processData: false,
          contentType: false,
          cache: false,
          data: formData,
        })
          .done((xhr) => {
            console.log(xhr);
            Swal.fire({
              text: xhr.data,
              customClass: "swal-popup swal-popup-form-success mr-30",
              timer: 2000,
              showConfirmButton: false,
              position: "top-end",
            }).then(() => {
              window.location.href = "/thank-you-seo";
            });
          })
          .fail((xhr) => {
            console.log(xhr.responseJSON.data);
            Swal.fire({
              text: xhr.responseJSON.data,
              customClass: "swal-popup swal-popup-form-error mr-30",
              timer: 1000,
              showConfirmButton: false,
              position: "top-end",
            });
          });
      }
    });
  };

  init();
};

try {
  formHomeSeo();
} catch (error) {
  console.error(error);
}
